// How the live operations page says a time, a run and a lag. Every time on this page is the
// reader's own — Central European, not UTC and not the floor's UK clock — because the reader is in
// Monaco and the page is about what is happening to him now. The floor's own day boundary is worked
// out in London on the server and arrives here as an instant, so nothing is converted twice.
const ZONE = 'Europe/Paris';

const hm = new Intl.DateTimeFormat('en-GB', { timeZone: ZONE, hour: '2-digit', minute: '2-digit', hour12: false });
const dayWords = new Intl.DateTimeFormat('en-GB', { timeZone: ZONE, weekday: 'long', day: 'numeric', month: 'long' });

export const at = (iso: string): string => hm.format(new Date(iso));
export const dayOf = (iso: string): string => dayWords.format(new Date(iso));

/** A run or a countdown, in the page's own words: minutes up to two hours, then hours and minutes. */
export function span(minutes: number): string {
  if (minutes < 0) return '0 min';
  if (minutes < 120) return minutes === 1 ? '1 min' : `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} hours` : `${h} h ${m} min`;
}

/** How long ago something landed. Null is never "now": it is nothing, and the caller says so. */
export function ago(iso: string | null, nowMs: number): string | null {
  if (iso === null) return null;
  const minutes = Math.floor((nowMs - Date.parse(iso)) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return hours === 1 ? '1 h ago' : `${hours} h ago`;
  return `${Math.floor(hours / 24)} days ago`;
}

export const plural = (n: number, one: string, many = `${one}s`): string => `${n.toLocaleString('en-GB')} ${n === 1 ? one : many}`;
